import { useEffect, useState } from "react"
import styles from "./styles.module.scss"
import { Menu } from "antd"
import Logo from "components/logo"
import UserSettings from "components/user-settings"
import { Link, useLocation } from "react-router-dom"
// import { ReactComponent as CartIcon } from "assets/icons/cart.svg"
// import CartContext from "providers/cart/context"
// import { useMemberId } from "pages/member"
export interface IHeader extends React.PropsWithChildren {
  items?: any[]
}

const Header: React.FC<IHeader> = ({ children, items }) => {
  const [sticky, setSticky] = useState(false)
  const location = useLocation()
  useEffect(() => {
    const scrollHandler = () =>
      setSticky(document.documentElement.scrollTop > 54)
    document.addEventListener("scroll", scrollHandler)
    return () => document.removeEventListener("scroll", scrollHandler)
  }, [setSticky])
  const getSelectedTab = () => {
    const path = location.pathname.split("/")
    const keys = items?.map((item) => item.key)
    return path.filter((value) => keys?.includes(value))
  }
  getSelectedTab()
  return (
    <>
      <nav className={styles.menu_nav}>
        <Link to="/" style={{ display: "flex" }}>
          <Logo />
        </Link>
        <div>
          <UserSettings />
        </div>
      </nav>
      {items && (
        <nav className={styles.submenu__wrapper}>
          <div
            className={`${styles.submenu} ${
              sticky ? styles.submenu_sticky : ""
            }`}
          >
            <div className={styles.submenu__inner}>
              <Menu
                style={{ width: "100%" }}
                selectedKeys={getSelectedTab()}
                mode="horizontal"
                items={items}
              />
            </div>
          </div>
        </nav>
      )}

      {children}
    </>
  )
}

export default Header
